import { useContext } from 'react';
import { useQuery } from '@apollo/client/react';

import { GET_WORK_ORDERS } from '@atom/graph/work';

import InventoryDetailContext from '../InventoryDetailContext';

import WorkOrdersFilterPanel from './filters/WorkOrdersFilterPanel';
import useWorkOrdersPageState from './useWorkOrdersPageState';
import WorkOrdersTable from './WorkOrdersTable';

import classes from './workOrdersTab.module.css';

const WorkOrdersTab = () => {
  const { asset } = useContext(InventoryDetailContext);

  const {
    page,
    limit,
    sortBy,
    sortDirection,
    filters,
    onFiltersApply,
    onSortChange,
    onPageChange,
    onLimitChange,
  } = useWorkOrdersPageState();

  const {
    data: { workOrders: { totalCount, workOrders } } = {
      workOrders: { totalCount: 0, workOrders: [] },
    },
    loading: loadingWorkOrders,
  } = useQuery(GET_WORK_ORDERS, {
    variables: {
      input: {
        page,
        limit,
        assetId: asset.id,
        sortBy: `${sortBy},${sortDirection}`,
        ...filters,
      },
    },
    fetchPolicy: 'no-cache',
  });

  return (
    <div className={classes.tabContent}>
      <div className={classes.filterPanelContainer}>
        <WorkOrdersFilterPanel
          schemaId={asset.schemaId}
          loadingWorkOrders={loadingWorkOrders}
          onFiltersApply={onFiltersApply}
        />
      </div>
      <div className={classes.tableContainer}>
        <WorkOrdersTable
          workOrders={workOrders}
          loadingWorkOrders={loadingWorkOrders}
          totalCount={totalCount}
          page={page}
          limit={limit}
          sortBy={sortBy}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
        />
      </div>
    </div>
  );
};

export default WorkOrdersTab;
